"use strict";
/*
 * Created on 2. 10. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ProjectionConverter_1 = require("./ProjectionConverter");
/**
 * Default implementation of {@link ProjectionConverter}.
 *
 * @author Radek Beran
 */


var ProjectionConverterImpl =
/*#__PURE__*/
function (_ProjectionConverter_) {
  _inherits(ProjectionConverterImpl, _ProjectionConverter_);

  function ProjectionConverterImpl() {
    _classCallCheck(this, ProjectionConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProjectionConverterImpl).apply(this, arguments));
  }

  _createClass(ProjectionConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return source;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      return source;
    }
  }]);

  return ProjectionConverterImpl;
}(ProjectionConverter_1.ProjectionConverter);

exports.ProjectionConverterImpl = ProjectionConverterImpl;